import { observer } from 'mobx-react-lite';

import { IcCommentsIcon } from '@gem/icons';
import { IconButton } from '@gem/ui-kit';

import usePresenter from './presenter';

const ThreadButton = ({ className, onClick }) => {
  const presenter = usePresenter({ onClick });

  if (!presenter.isShow) {
    return null;
  }

  return (
    <IconButton
      Icon={IcCommentsIcon}
      onClick={presenter.goToThread}
      className={className}
      size="large"
      iconSize="medium"
      theme="12"
      text={presenter.commentsCount}
    />
  );
};

export default observer(ThreadButton);
